var map = {
	"./datastories-logo.svg": "fef3",
	"./icon-close.svg": "3c76",
	"./icon-info.svg": "1531",
	"./icon-plus.svg": "77ea",
	"./sandra-davie.png": "fec3",
	"./school-header.svg": "3e24",
	"./school.gif": "de4f",
	"./survey-banner-mobile.svg": "70bf",
	"./survey-banner.svg": "7c4e",
	"./template/image-background-header-desktop.jpg": "5c5b",
	"./template/image-background-header.jpg": "32e0",
	"./template/sample-image-desktop.png": "3100",
	"./template/sample-image.png": "da96",
	"./template/sample-logo.svg": "2bfb"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7584";